//
import { Component } from "react"
// eslint-disable-next-line
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups"
import {
    DisbursementsTypeFilter,
    DisbursementsRecipientTypeFilter,
    DisbursementsDateStartFilter,
    DisbursementsDateEndFilter,
    DisbursementsAmountMinFilter,
    DisbursementsAmountMaxFilter,
    DisbursementsDisburserFilter,
    DisbursementsPoliticalCommitteeFilter,
} from "shared/search/containers/Filter/DisbursementsFilters"

export class DisbursementsTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [DisbursementsTypeFilter, DisbursementsDisburserFilter],
        uniqueFilterGroupId: "disbursementsTypeFilterGroup",
        displayLabel: "Disburser",
        helpText: "Filter by disburser.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class DisbursementsRecipientTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [DisbursementsRecipientTypeFilter, DisbursementsPoliticalCommitteeFilter],
        uniqueFilterGroupId: "disbursementsRecipientTypeFilterGroup",
        displayLabel: "Recipient",
        helpText: "Filter by recipient.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class DisbursementsPoliticalCommitteeTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [DisbursementsTypeFilter],
        uniqueFilterGroupId: "disbursementsPoliticalCommitteeTypeFilterGroup",
        displayLabel: "Disburser",
        helpText: "Filter by disburser.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class DisbursementsDateFilterGroup extends Component {
    static defaultProps = {
        filters: [DisbursementsDateStartFilter, DisbursementsDateEndFilter],
        uniqueFilterGroupId: "disbursementsDateFilterGroup",
        displayLabel: "Date",
        helpText: "Filter by date.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class DisbursementsAmountMinFilterGroup extends Component {
    static defaultProps = {
        filters: [DisbursementsAmountMinFilter, DisbursementsAmountMaxFilter],
        uniqueFilterGroupId: "DisbursementsAmountMinFilterGroup",
        displayLabel: "Amount",
        helpText: "Filter by amount.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
